export default __webpack_public_path__ + "889932c4d24db0cebcdf74d722408121.jpg";